import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const CarIcon: FC<IconProps> = ({ width = 33, height = 16, ...rest }) => (
  <Icon type="CarCyan" width={width} height={height} alt="CarIconCyan" {...rest} />
)
